<script setup>
import {computed, onUnmounted} from 'vue'
import {useRoute} from 'vue-router'

const props = defineProps({
    reportsModule: {
        type: Object,
        required: true
    }
})

const route = useRoute()

const formData = computed(() => props.reportsModule?.formData || {})

const initRouteQueryState = () => {
    formData.value.startDate = route.query?.startDate || ''
    formData.value.endDate = route.query?.endDate || ''
}
initRouteQueryState()

onUnmounted(() => {
    if (formData.value) {
        delete formData.value.startDate
        delete formData.value.endDate
    }
})
</script>

<template>
    <span class="d-flex align-items-center">
        <input
            type="date"
            required
            v-model="formData.startDate"
            class="form-control form-control-sm"
            oninvalid="this.setCustomValidity('Please enter a start date')"
            oninput="this.setCustomValidity('')"
        >
        <span class="ms-2 text-muted">to</span>
        <input
            type="date"
            required
            v-model="formData.endDate"
            class="ms-2 form-control form-control-sm"
            oninvalid="this.setCustomValidity('Please enter an end date')"
            oninput="this.setCustomValidity('')"
        >
    </span>
</template>